/**
 * Build a link to a FinMaple comparator with query params for attribution.
 */
export function buildComparatorLink(lng, path, params = {}) {
  const base = `/${lng}/${path}`;
  const searchParams = new URLSearchParams({
    ...params,
    source: 'budget-planner',
  });
  return `${base}?${searchParams.toString()}`;
}
